import { render, staticRenderFns } from "./vsBreadcrumb.vue?vue&type=template&id=a0040c92&lang=html&"
import script from "./vsBreadcrumb.vue?vue&type=script&lang=js&"
export * from "./vsBreadcrumb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "vsBreadcrumb.vue"
export default component.exports